import {IStandardAPIResponse,  IReadingStatus, ISearchSmps, ISMPSReading } from "../../vm";
import { httpClient, handleErrorResp } from "../UtilService";

export async function getSmpsList(datacenterId:string): Promise<IStandardAPIResponse<Array<any>>> {
    try {
      let res = await httpClient<Array<any>>(`smps-list/${datacenterId}`, "GET");
      return res;
    } catch (err) {
      return handleErrorResp([]);
    }
  }

export async function getSmpsReadings(obj:ISearchSmps): Promise<IStandardAPIResponse<Array<ISMPSReading>>> {
    try {
      let res = await httpClient<Array<ISMPSReading>>(`smps-readings`, "GET",obj);
      return res;
    } catch (err) {
      return handleErrorResp([]);
    }
  }
export async function updateSmpsReadingStatus(obj:IReadingStatus): Promise<IStandardAPIResponse<any>> {
    try {
      let res = await httpClient<any>(`smps-readings/status`, "PATCH",obj);
      return res;
    } catch (err) {
      return handleErrorResp([]);
    }
  }
export async function updateSmpsReading(obj:ISMPSReading): Promise<IStandardAPIResponse<ISMPSReading>> {
    try {
      let res = await httpClient<ISMPSReading>(`smps-readings/${obj._id}`, "PATCH",obj);
      return res;
    } catch (err) {
      return handleErrorResp([]);
    }
  }